export default __webpack_public_path__ + "static/media/caen16.daef1032.jpg";